import * as React from 'react';
import * as classNames from 'classnames';

import {
    Bulma,
    removeStateProps, removeColorProps, removeLoadingProps,
    getStateModifiers, getColorModifiers, getLoadingModifiers,
    withHelpersModifiers,
} from './../bulma';
import { combineModifiers, getHTMLProps } from './../helpers';

export interface Button<T> extends
    Bulma.Render, Bulma.State, Bulma.Color, Bulma.Loading,
    React.HTMLProps<T> {
    isLink?: boolean,
    isOutlined?: boolean,
    isInverted?: boolean,
    isStatic?: boolean,
}

export const Button: React.SFC<Button<HTMLButtonElement | HTMLAnchorElement>> = (props) => {
    const className = classNames(
        'button',
        {
            'is-link': props.isLink,
            'is-outlined': props.isOutlined,
            'is-inverted': props.isInverted,
            'is-static': props.isStatic,
            ...combineModifiers(props, getStateModifiers, getColorModifiers, getLoadingModifiers)
        },
        props.className,
    );
    const { render, isLink, isOutlined, isInverted, isStatic, ...rest } = props;
    const HTMLProps = getHTMLProps(
        rest,
        removeStateProps,
        removeColorProps,
        removeLoadingProps,
    );

    if (render) return render({ ...HTMLProps, className });

    const anchor = (
        <a {...HTMLProps} role='button' className={className} />
    )

    const button = (
        <button {...HTMLProps} type={props.type || 'button'} className={className} />
    )

    return props.href ? anchor : button;
}

export default withHelpersModifiers(Button);


// WEBPACK FOOTER //
// ./src/elements/Button.tsx